module.exports = __webpack_public_path__ + "img/sirui.22f8518d.png";